module.exports = __webpack_public_path__ + "img/save2.47783127.png";